// Module
var code = "<div id=\"{{id}}\" class=\"{{class}}\"> <iframe src=\"{{source}}\"></iframe> </div>";
// Exports
module.exports = code;